export const HEADER_TABLE = [
  "Nome",
  "E-mail",
  "Razão social",
  "Tipo de usuário",
  "Cadastrado por",
  "Data de cadastro",
  "",
];

export const KindUser: Record<string, string> = {
  customer: "cliente",
  driver: "motorista",
  cif_driver: "motorista cif",
  carrier: "transportadora",
};
